// extracted by mini-css-extract-plugin
export default {"noStyle":"noStyle-H87hr","iconBefore":"iconBefore-WgncF"};